"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var Col_1 = __importDefault(require("../Col"));
var FormatText_1 = __importDefault(require("../FormatText"));
var Widget = function (props) {
    var span = props.span, toolbar = props.toolbar, title = props.title, children = props.children, cardProps = __rest(props, ["span", "toolbar", "title", "children"]);
    var resolvedTitle = typeof title === 'string' ? react_1.default.createElement(FormatText_1.default, { id: title }) : title;
    return (react_1.default.createElement(Col_1.default, { span: span },
        react_1.default.createElement(antd_1.Card, __assign({ title: resolvedTitle, extra: toolbar }, cardProps, { bordered: false }), children)));
};
exports.default = Widget;
